import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AdminLoginScreen = () => {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Get admin password from environment variable
      const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD || 'admin123';
      
      if (password === adminPassword) {
        localStorage.setItem('is_admin', 'true');
        toast.success('Admin access granted!');
        navigate('/admin/dashboard');
      } else {
        toast.error('Invalid admin password');
      }
    } catch (error) {
      toast.error('An error occurred during authentication');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="admin-login-card">
        <div className="admin-login-header">
        <img src="/logo.svg" alt="Project 31 Logo" className="login-logo" />
       
        </div>
        
        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="form-group">
            <label htmlFor="password">Admin Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              required
              disabled={isLoading}
            />
          </div>
          
          <button 
            type="submit" 
            className="admin-login-button"
            disabled={isLoading || !password.trim()}
          >
            {isLoading ? 'Authenticating...' : 'Access Admin Panel'}
          </button>
        </form>
        
        <div className="admin-login-footer">
          <button 
            onClick={() => navigate('/')}
            className="back-button"
          >
            ← Back to Main App
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginScreen;
